import makeStyles from '@material-ui/core/styles/makeStyles';

interface CheckboxFieldProps {
  borderRadius: number;
}

export const useStyles = makeStyles(theme => ({
  paper: {
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit',
    backgroundColor: theme.palette.common.white,
    borderRadius: ({ borderRadius }: CheckboxFieldProps) => borderRadius,
    boxShadow: '2px 3px 10px #7777771A',
  },
}));
